const LOAD_DETAIL_XPERT           = 'LOAD_DETAIL_XPERT'
const LOAD_DETAIL_XPERT_SUCCESS   = 'LOAD_DETAIL_XPERT_SUCCESS'
const LOAD_DETAIL_XPERT_FAILED    = 'LOAD_DETAIL_XPERT_FAILED'
const UNMOUNT_DETAIL_XPERT        = 'UNMOUNT_DETAIL_XPERT'
const initialState = {
  loading: true,
  data: null,
  message: null,
}
const xpertDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_XPERT:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_XPERT_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_XPERT_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_XPERT:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}
export default xpertDetailReducer;